// import React from 'react';

// const ContactUs = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   const infoStyle = {
//     display: "flex",
//     alignItems: "flex-start",
//     gap: "20px",
//     marginBottom: "30px",
//     padding: "20px",
//     borderRadius: "12px",
//     background: "#f9f9f9",
//     borderLeft: `5px solid ${primaryColor}`
//   };

//   const iconStyle = {
//     fontSize: "1.5rem",
//     background: "#fff",
//     padding: "10px",
//     borderRadius: "50%",
//     boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
//   };

//   return (
//     <div style={{ paddingTop: "140px", backgroundColor: "#fff", minHeight: "100vh", fontFamily: "Segoe UI, sans-serif" }}>
      
//       <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "40px 20px" }}>
        
//         {/* HEADER */}
//         <div style={{ textAlign: "center", marginBottom: "60px" }}>
//           <h1 style={{ color: primaryColor, fontSize: "3rem", fontWeight: "800" }}>"We'd Love to Hear from You"</h1>
//           <p style={{ fontSize: "1.2rem", color: "#666", maxWidth: "800px", margin: "20px auto" }}>
//             Whether you're a parent exploring admissions, a student curious about our programs, or someone who simply wants to know more — our doors are always open.
//           </p>
//         </div>

//         <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
          
//           {/* LEFT COLUMN: CONTACT DETAILS */}
//           <div style={{ flex: "1 1 500px" }}>
//             <h2 style={{ marginBottom: "30px", color: "#333" }}>Get In Touch</h2>
            
//             <div style={infoStyle}>
//               <span style={iconStyle}>📍</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Address</h4>
//                 <p style={{ color: "#555" }}>Ward No. 1, Gobindpuri Colony, Opp. Reliance Petrol Pump, Pipli Road, Ladwa, Dist. Kurukshetra — 136 132, Haryana</p>
//               </div>
//             </div>

//             <div style={infoStyle}>
//               <span style={iconStyle}>📞</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Phone</h4>
//                 <p style={{ color: "#555" }}>+91-90534-90023 | +91-72068-66235</p>
//                 <p style={{ color: "#555" }}>+91-80530-70125 | +91-99965-90023</p>
//               </div>
//             </div>

//             <div style={infoStyle}>
//               <span style={iconStyle}>✉️</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Email</h4>
//                 <p style={{ color: "#555" }}>dpskidsladwa@gmail.com</p>
//               </div>
//             </div>

//             <div style={infoStyle}>
//               <span style={iconStyle}>🎖️</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>CBSE Affiliation</h4>
//                 <p style={{ color: "#555" }}>Permanent Affiliated C.B.S.E. | No. 532056</p>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN: CALL TO ACTION */}
//           <div style={{ 
//             flex: "1 1 400px", 
//             background: primaryColor, 
//             padding: "40px", 
//             borderRadius: "25px", 
//             color: "#fff",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             boxShadow: "0 15px 35px rgba(0,111,47,0.2)"
//           }}>
//             <h2 style={{ fontSize: "2rem", marginBottom: "20px" }}>Ready to Give Your Child the Best Start?</h2>
//             <p style={{ marginBottom: "30px", opacity: "0.9", lineHeight: "1.6" }}>
//               Schedule a school visit today and experience DPS Kids for yourself. We are always ready to welcome you.
//             </p>
            
//             <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
//               <button style={btnStyle("#fff", primaryColor)}>📅 Book a Visit</button>
//               <button style={btnStyle("transparent", "#fff", "1px solid #fff")}>📞 Call Now</button>
//               <button style={btnStyle("transparent", "#fff", "1px solid #fff")}>💬 Send a Message</button>
//             </div>
//           </div>

//         </div>

//         {/* MAP PLACEHOLDER */}
//         <div style={{ 
//           marginTop: "80px", 
//           height: "400px", 
//           background: "#eee", 
//           borderRadius: "20px", 
//           display: "flex", 
//           alignItems: "center", 
//           justifyContent: "center",
//           color: "#999",
//           fontSize: "1.2rem",
//           border: "1px dashed #ccc"
//         }}>
//           [ Google Maps Will Be Integrated Here ]
//         </div>

//       </div>
//     </div>
//   );
// };

// // Button Helper Style
// const btnStyle = (bg, color, border = "none") => ({
//   padding: "15px 25px",
//   borderRadius: "30px",
//   border: border,
//   background: bg,
//   color: color,
//   fontSize: "1rem",
//   fontWeight: "bold",
//   cursor: "pointer",
//   transition: "0.3s",
// });

// export default ContactUs;

// import React from 'react';

// const ContactUs = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   // Google Map ka Link (Aap is 'src' ko replace kar sakte hain agar exact location chahiye)
//   const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.968444453535!2d77.03964527535492!3d29.998495474944885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390e1636279930f9%3A0x6d39352e8276f538!2sLadwa%2C%20Haryana%20136132!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin";

//   const infoStyle = {
//     display: "flex",
//     alignItems: "flex-start",
//     gap: "20px",
//     marginBottom: "30px",
//     padding: "20px",
//     borderRadius: "12px",
//     background: "#f9f9f9",
//     borderLeft: `5px solid ${primaryColor}`,
//     transition: "0.4s",
//     cursor: "pointer"
//   };

//   return (
//     <div style={{ paddingTop: "140px", backgroundColor: "#fff", minHeight: "100vh", fontFamily: "Segoe UI, sans-serif" }}>
      
//       {/* 🖼️ TOP BANNER FOR CONTACT */}
//       <div style={{
//         width: "100%",
//         height: "250px",
//         background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('https://images.unsplash.com/photo-1534536281715-e28d76689b4d?auto=format&fit=crop&w=1350&q=80')`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         color: "#fff",
//         marginBottom: "50px"
//       }}>
//         <h1 style={{ fontSize: "3.5rem", fontWeight: "800" }}>Contact Us</h1>
//       </div>

//       <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px" }}>
        
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
          
//           {/* LEFT COLUMN: CONTACT DETAILS WITH ANIMATIONS */}
//           <div style={{ flex: "1 1 500px" }}>
//             <h2 style={{ marginBottom: "30px", color: "#333" }}>Get In Touch</h2>
            
//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>📍</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Address</h4>
//                 <p style={{ color: "#555" }}>Ward No. 1, Gobindpuri Colony, Opp. Reliance Petrol Pump, Pipli Road, Ladwa, Dist. Kurukshetra — 136 132, Haryana</p>
//               </div>
//             </div>

//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>📞</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Phone</h4>
//                 <p style={{ color: "#555" }}>+91-90534-90023 | +91-72068-66235</p>
//               </div>
//             </div>

//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>✉️</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Email</h4>
//                 <p style={{ color: "#555" }}>dpskidsladwa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN: ACTION BOX */}
//           <div style={{ 
//             flex: "1 1 400px", 
//             background: primaryColor, 
//             padding: "40px", 
//             borderRadius: "25px", 
//             color: "#fff",
//             boxShadow: "0 15px 35px rgba(0,111,47,0.3)",
//             animation: "slideIn 1s ease-out"
//           }}>
//             <h2 style={{ fontSize: "2rem", marginBottom: "20px" }}>Ready to Visit?</h2>
//             <p style={{ marginBottom: "30px", opacity: "0.9" }}>Experience DPS Kids Ladwa firsthand. We are excited to meet you!</p>
            
//             <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
//               <button className="cta-btn">📅 Book a Visit</button>
//               <button className="cta-btn secondary">📞 Call Now</button>
//             </div>
//           </div>
//         </div>

//         {/* 🗺️ GOOGLE MAP INTEGRATION */}
//         <div style={{ marginTop: "80px", borderRadius: "20px", overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,0.1)", height: "450px" }}>
//           <iframe 
//             src={mapUrl}
//             width="100%" 
//             height="100%" 
//             style={{ border: 0 }} 
//             allowFullScreen="" 
//             loading="lazy" 
//             referrerPolicy="no-referrer-when-downgrade"
//             title="School Location"
//           ></iframe>
//         </div>
//       </div>

//       {/* 🔮 ANIMATIONS & CSS */}
//       <style>
//         {`
//           @keyframes slideIn {
//             from { opacity: 0; transform: translateX(50px); }
//             to { opacity: 1; transform: translateX(0); }
//           }

//           .contact-card:hover {
//             transform: scale(1.03) translateX(10px);
//             background: #fff !important;
//             box-shadow: 0 10px 20px rgba(0,0,0,0.05);
//           }

//           .cta-btn {
//             padding: 15px;
//             border-radius: 30px;
//             border: none;
//             background: #fff;
//             color: ${primaryColor};
//             font-weight: bold;
//             cursor: pointer;
//             transition: 0.3s;
//           }

//           .cta-btn:hover {
//             transform: translateY(-3px);
//             box-shadow: 0 5px 15px rgba(255,255,255,0.4);
//           }

//           .cta-btn.secondary {
//             background: transparent;
//             border: 1px solid #fff;
//             color: #fff;
//           }

//           .cta-btn.secondary:hover {
//             background: #fff;
//             color: ${primaryColor};
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const iconStyle = {
//   fontSize: "1.5rem",
//   background: "#fff",
//   padding: "10px",
//   borderRadius: "50%",
//   boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
// };

// export default ContactUs;

// import React from "react";

// const ContactUs = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   // Google Map ka Link (Aap is 'src' ko replace kar sakte hain agar exact location chahiye)
//   const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.968444453535!2d77.03964527535492!3d29.998495474944885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390e1636279930f9%3A0x6d39352e8276f538!2sLadwa%2C%20Haryana%20136132!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin";

//   const infoStyle = {
//     display: "flex",
//     alignItems: "flex-start",
//     gap: "20px",
//     marginBottom: "30px",
//     padding: "20px",
//     borderRadius: "12px",
//     background: "#f9f9f9",
//     borderLeft: `5px solid ${primaryColor}`,
//     transition: "0.4s",
//     cursor: "pointer"
//   };

//   return (
//     <div style={styles.page}>
//       {/* 🔥 TOP BANNER IMAGE - SAME SIZE AS SPORTS (420px) */}
//       <div style={styles.bannerHero}>
//         <img
//           src="https://images.unsplash.com/photo-1534536281715-e28d76689b4d?auto=format&fit=crop&w=1920&q=85"
//           alt="DPS Kids Contact Us Banner"
//           style={styles.bannerImage}
//         />
//         <div style={styles.bannerOverlay} />
//         <div style={styles.bannerContent}>
//           <div style={styles.bannerBadge}>📞 CONNECT WITH US</div>
//           <h1 style={styles.bannerTitle}>Contact Us</h1>
//           <p style={styles.bannerSubtitle}>We're here to help you every step of the way</p>
//         </div>
//       </div>

//       <div style={styles.section}>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
          
//           {/* LEFT COLUMN: CONTACT DETAILS WITH ANIMATIONS */}
//           <div style={{ flex: "1 1 500px" }}>
//             <h2 style={{ marginBottom: "30px", color: "#333" }}>Get In Touch</h2>
            
//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>📍</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Address</h4>
//                 <p style={{ color: "#555" }}>Ward No. 1, Gobindpuri Colony, Opp. Reliance Petrol Pump, Pipli Road, Ladwa, Dist. Kurukshetra — 136 132, Haryana</p>
//               </div>
//             </div>

//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>📞</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Phone</h4>
//                 <p style={{ color: "#555" }}>+91-90534-90023 | +91-72068-66235</p>
//               </div>
//             </div>

//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>✉️</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Email</h4>
//                 <p style={{ color: "#555" }}>dpskidsladwa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN: ACTION BOX */}
//           <div style={{ 
//             flex: "1 1 400px", 
//             background: primaryColor, 
//             padding: "40px", 
//             borderRadius: "25px", 
//             color: "#fff",
//             boxShadow: "0 15px 35px rgba(0,111,47,0.3)",
//             animation: "slideIn 1s ease-out"
//           }}>
//             <h2 style={{ fontSize: "2rem", marginBottom: "20px" }}>Ready to Visit?</h2>
//             <p style={{ marginBottom: "30px", opacity: "0.9" }}>Experience DPS Kids Ladwa firsthand. We are excited to meet you!</p>
            
//             <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
//               <button className="cta-btn">📅 Book a Visit</button>
//               <button className="cta-btn secondary">📞 Call Now</button>
//             </div>
//           </div>
//         </div>

//         {/* 🗺️ GOOGLE MAP INTEGRATION */}
//         <div style={{ marginTop: "80px", borderRadius: "20px", overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,0.1)", height: "450px" }}>
//           <iframe 
//             src={mapUrl}
//             width="100%" 
//             height="100%" 
//             style={{ border: 0 }} 
//             allowFullScreen="" 
//             loading="lazy" 
//             referrerPolicy="no-referrer-when-downgrade"
//             title="School Location"
//           ></iframe>
//         </div>
//       </div>

//       {/* 🔮 ANIMATIONS & CSS */}
//       <style>
//         {`
//           @keyframes slideIn {
//             from { opacity: 0; transform: translateX(50px); }
//             to { opacity: 1; transform: translateX(0); }
//           }

//           .contact-card:hover {
//             transform: scale(1.03) translateX(10px);
//             background: #fff !important;
//             box-shadow: 0 10px 20px rgba(0,0,0,0.05);
//           }

//           .cta-btn {
//             padding: 15px;
//             border-radius: 30px;
//             border: none;
//             background: #fff;
//             color: ${primaryColor};
//             font-weight: bold;
//             cursor: pointer;
//             transition: 0.3s;
//           }

//           .cta-btn:hover {
//             transform: translateY(-3px);
//             box-shadow: 0 5px 15px rgba(255,255,255,0.4);
//           }

//           .cta-btn.secondary {
//             background: transparent;
//             border: 1px solid #fff;
//             color: #fff;
//           }

//           .cta-btn.secondary:hover {
//             background: #fff;
//             color: ${primaryColor};
//           }

//           @media (max-width: 768px) {
//             .banner-stats {
//               flex-direction: column !important;
//               gap: 15px !important;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const iconStyle = {
//   fontSize: "1.5rem",
//   background: "#fff",
//   padding: "10px",
//   borderRadius: "50%",
//   boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
// };

// // 🔥 NEW SHARED BANNER STYLES (SAME SIZE AS SPORTS - 420px)
// const styles = {
//   page: {
//     paddingTop: "0px", // Banner full top
//     backgroundColor: "#fff",
//     minHeight: "100vh",
//     fontFamily: "Segoe UI, sans-serif",
//     overflowX: "hidden",
//   },
//   bannerHero: {
//     position: "relative",
//     width: "100%",
//     height: "420px", // ✅ SAME SIZE AS SPORTS FITNESS
//     overflow: "hidden",
//     marginBottom: "0",
//   },
//   bannerImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     objectPosition: "center",
//     display: "block",
//     transition: "transform 0.6s ease",
//   },
//   bannerOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(135deg, rgba(0,111,47,0.75) 0%, rgba(0,0,0,0.6) 100%)",
//     zIndex: 1,
//   },
//   bannerContent: {
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     padding: "0 30px",
//     zIndex: 2,
//     color: "#fff",
//   },
//   bannerBadge: {
//     background: "rgba(255,215,0,0.9)",
//     color: "#000",
//     padding: "8px 24px",
//     borderRadius: "50px",
//     fontSize: "0.9rem",
//     fontWeight: "700",
//     letterSpacing: "1px",
//     marginBottom: "20px",
//     boxShadow: "0 4px 15px rgba(255,215,0,0.4)",
//     animation: "pulse 2s infinite",
//   },
//   bannerTitle: {
//     fontSize: "clamp(2.5rem, 6vw, 4rem)",
//     fontWeight: "900",
//     marginBottom: "15px",
//     textShadow: "0 4px 20px rgba(0,0,0,0.5)",
//     letterSpacing: "-0.02em",
//     lineHeight: 1.1,
//   },
//   bannerSubtitle: {
//     fontSize: "clamp(1.1rem, 2.5vw, 1.6rem)",
//     fontWeight: "300",
//     marginBottom: "0",
//     opacity: 0.95,
//     maxWidth: "600px",
//   },
//   section: {
//     maxWidth: "1100px",
//     margin: "0 auto",
//     padding: "60px 20px",
//   },
// };

// // Add pulse animation to style tag if needed
// const pulseKeyframes = `
// @keyframes pulse {
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// }
// `;

// export default ContactUs;

// import React, { useState } from "react";

// const ContactUs = () => {
//   const primaryColor = "rgb(0, 111, 47)";
  
//   // 🔥 State to handle Modal visibility
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3450.4821213271714!2d77.0423013!3d30.0803405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzDCsDA0JzQ5LjIiTiA3N8KwMDInMzIuMyJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin";

//   const infoStyle = {
//     display: "flex",
//     alignItems: "flex-start",
//     gap: "20px",
//     marginBottom: "30px",
//     padding: "20px",
//     borderRadius: "12px",
//     background: "#f9f9f9",
//     borderLeft: `5px solid ${primaryColor}`,
//     transition: "0.4s",
//     cursor: "pointer"
//   };

//   return (
//     <div style={styles.page}>
//       {/* 🔥 TOP BANNER IMAGE */}
//       <div style={styles.bannerHero}>
//         <img
//           src="https://images.unsplash.com/photo-1534536281715-e28d76689b4d?auto=format&fit=crop&w=1920&q=85"
//           alt="DPS Kids Contact Us Banner"
//           style={styles.bannerImage}
//         />
//         <div style={styles.bannerOverlay} />
//         <div style={styles.bannerContent}>
//           <div style={styles.bannerBadge}>📞 CONNECT WITH US</div>
//           <h1 style={styles.bannerTitle}>Contact Us</h1>
//           <p style={styles.bannerSubtitle}>We're here to help you every step of the way</p>
//         </div>
//       </div>

//       <div style={styles.section}>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
          
//           {/* LEFT COLUMN: CONTACT DETAILS */}
//           <div style={{ flex: "1 1 500px" }}>
//             <h2 style={{ marginBottom: "30px", color: "#333" }}>Get In Touch</h2>
//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>📍</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Address</h4>
//                 <p style={{ color: "#555" }}>Ward No. 1, Gobindpuri Colony, Opp. Reliance Petrol Pump, Pipli Road, Ladwa, Dist. Kurukshetra — 136 132, Haryana</p>
//               </div>
//             </div>
//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>📞</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Phone</h4>
//                 <p style={{ color: "#555" }}>+91-90534-90023 | +91-72068-66235</p>
//               </div>
//             </div>
//             <div className="contact-card" style={infoStyle}>
//               <span style={iconStyle}>✉️</span>
//               <div>
//                 <h4 style={{ color: primaryColor, marginBottom: "5px" }}>Email</h4>
//                 <p style={{ color: "#555" }}>dpskidsladwa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN: ACTION BOX */}
//           <div style={styles.actionBox}>
//             <h2 style={{ fontSize: "2rem", marginBottom: "20px" }}>Ready to Visit?</h2>
//             <p style={{ marginBottom: "30px", opacity: "0.9" }}>Experience DPS Kids Ladwa firsthand. We are excited to meet you!</p>
//             <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
//               <button className="cta-btn" onClick={() => setIsModalOpen(true)}>📅 Book a Visit</button>
//               <button className="cta-btn secondary">📞 Call Now</button>
//             </div>
//           </div>
//         </div>

//         {/* 🗺️ MAP */}
//         <div style={styles.mapContainer}>
//           <iframe src={mapUrl} width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" title="School Location"></iframe>
//         </div>
//       </div>

//       {/* 🚀 ANIMATED MODAL FORM */}
//       {isModalOpen && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modalContent}>
//             <button style={styles.closeBtn} onClick={() => setIsModalOpen(false)}>×</button>
//             <h2 style={{ color: primaryColor, textAlign: "center", marginBottom: "20px" }}>Schedule School Visit</h2>
//             <form style={styles.form} onSubmit={(e) => { e.preventDefault(); alert("Visit Request Sent!"); setIsModalOpen(false); }}>
//               <input type="text" placeholder="Parent's Name" style={styles.input} required />
//               <input type="tel" placeholder="Phone Number" style={styles.input} required />
//               <input type="email" placeholder="Email Address" style={styles.input} />
//               <input type="date" style={styles.input} required />
//               <select style={styles.input}>
//                 <option>Select Class for Admission</option>
//                 <option>Pre-Nursery</option>
//                 <option>Nursery</option>
//                 <option>Prep / KG</option>
//                 <option>Primary</option>
//               </select>
//               <textarea placeholder="Any specific questions?" style={{ ...styles.input, height: "80px" }}></textarea>
//               <button type="submit" style={styles.submitBtn}>Submit Request</button>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* 🔮 ANIMATIONS & CSS */}
//       <style>
//         {`
//           @keyframes slideIn { from { opacity: 0; transform: translateX(50px); } to { opacity: 1; transform: translateX(0); } }
//           @keyframes zoomIn { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
//           @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
          
//           .contact-card:hover { transform: scale(1.03) translateX(10px); background: #fff !important; box-shadow: 0 10px 20px rgba(0,0,0,0.05); }
//           .cta-btn { padding: 15px; border-radius: 30px; border: none; background: #fff; color: ${primaryColor}; font-weight: bold; cursor: pointer; transition: 0.3s; }
//           .cta-btn:hover { transform: translateY(-3px); box-shadow: 0 5px 15px rgba(255,255,255,0.4); }
//           .cta-btn.secondary { background: transparent; border: 1px solid #fff; color: #fff; }
//           .cta-btn.secondary:hover { background: #fff; color: ${primaryColor}; }
//         `}
//       </style>
//     </div>
//   );
// };

// const iconStyle = { fontSize: "1.5rem", background: "#fff", padding: "10px", borderRadius: "50%", boxShadow: "0 4px 10px rgba(0,0,0,0.05)" };

// const styles = {
//   page: { paddingTop: "0px", backgroundColor: "#fff", minHeight: "100vh", fontFamily: "Segoe UI, sans-serif", overflowX: "hidden" },
//   bannerHero: { position: "relative", width: "100%", height: "420px", overflow: "hidden" },
//   bannerImage: { width: "100%", height: "100%", objectFit: "cover" },
//   bannerOverlay: { position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(0,111,47,0.75) 0%, rgba(0,0,0,0.6) 100%)", zIndex: 1 },
//   bannerContent: { position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", zIndex: 2, color: "#fff" },
//   bannerBadge: { background: "rgba(255,215,0,0.9)", color: "#000", padding: "8px 24px", borderRadius: "50px", fontWeight: "700", marginBottom: "20px" },
//   bannerTitle: { fontSize: "clamp(2.5rem, 6vw, 4rem)", fontWeight: "900", marginBottom: "15px" },
//   bannerSubtitle: { fontSize: "clamp(1.1rem, 2.5vw, 1.6rem)", fontWeight: "300", opacity: 0.95 },
//   section: { maxWidth: "1100px", margin: "0 auto", padding: "60px 20px" },
//   actionBox: { flex: "1 1 400px", background: "rgb(0, 111, 47)", padding: "40px", borderRadius: "25px", color: "#fff", animation: "slideIn 1s ease-out" },
//   mapContainer: { marginTop: "80px", borderRadius: "20px", overflow: "hidden", height: "450px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" },
  
//   // 🔥 MODAL STYLES
//    // 🔥 UPDATED COMPACT MODAL STYLES
//   modalOverlay: { 
//     position: "fixed", 
//     inset: 0, 
//     background: "rgba(0,0,0,0.75)", 
//     display: "flex", 
//     alignItems: "center", 
//     justifyContent: "center", 
//     zIndex: 1000, 
//     padding: "10px", // Mobile par thoda gap rahega
//     animation: "fadeIn 0.2s ease" 
//   },
//   modalContent: { 
//     background: "#fff", 
//     padding: "20px 25px", // Padding kam ki hai (40px se 20px)
//     borderRadius: "15px", 
//     width: "95%", 
//     maxWidth: "400px", // Width choti ki hai (500px se 400px)
//     maxHeight: "85vh", // Screen height ka 85% tak hi rahega
//     overflowY: "auto", 
//     position: "relative", 
//     boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
//     animation: "zoomIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)" 
//   },
//   closeBtn: { 
//     position: "absolute", 
//     top: "8px", 
//     right: "12px", 
//     fontSize: "24px", // Icon chota kiya
//     border: "none", 
//     background: "none", 
//     cursor: "pointer", 
//     color: "#999",
//     zIndex: 10
//   },
//   form: { 
//     display: "flex", 
//     flexDirection: "column", 
//     gap: "10px" // Inputs ke beech ka gap kam kiya
//   },
//   input: { 
//     padding: "10px 12px", // Input height kam ki
//     borderRadius: "6px", 
//     border: "1px solid #ddd", 
//     fontSize: "0.9rem", // Text chota kiya
//     outline: "none", 
//     fontFamily: "inherit",
//     width: "100%",
//     boxSizing: "border-box"
//   },
//   submitBtn: { 
//     padding: "10px", 
//     marginTop: "5px",
//     borderRadius: "6px", 
//     border: "none", 
//     background: "rgb(0, 111, 47)", 
//     color: "#fff", 
//     fontSize: "1rem", 
//     fontWeight: "bold", 
//     cursor: "pointer", 
//     transition: "0.3s" 
//   },
//   form: { display: "flex", flexDirection: "column", gap: "15px" },
//   input: { padding: "12px 15px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "1rem", outline: "none", fontFamily: "inherit" },
//   submitBtn: { padding: "15px", borderRadius: "8px", border: "none", background: "rgb(0, 111, 47)", color: "#fff", fontSize: "1.1rem", fontWeight: "bold", cursor: "pointer", transition: "0.3s" }
// };

// export default ContactUs;

import React, { useState } from "react";

const ContactUs = () => {
  const primaryColor = "rgb(0, 111, 47)";
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Google Maps URL (Aap apna real map embed link yahan replace kar sakte hain)
  //const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.4682337785536!2d77.0722122!3d30.0090885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390e16723e74235b%3A0x6c6e76839564887!2sPipli%20Road%2C%20Ladwa!5e0!3m2!1sen!2sin!4v1710000000000";
const mapUrl = "https://maps.google.com/maps?q=X2WM+4H+Ladwa,Haryana&output=embed";
  const handleSubmit = async (e) => {
  e.preventDefault();

  const form = new FormData(e.target);

  try {
    const response = await fetch(
      "https://dpsladwa.com/Dpsschool_Data/sendmail.php",
      {
        method: "POST",
        body: form,
      }
    );

    const result = await response.json();
    console.log(result);

    if (result.status) {
      alert("Request sent successfully!");
      setIsModalOpen(false);
    } else {
      alert(result.error || "Something went wrong");
    }
  } catch (error) {
    console.log(error);
    alert("Server error");
  }
};
  return (
    <div style={styles.page}>
      {/* 🖼️ TOP BANNER */}
      <div style={styles.bannerHero}>
        <img
          src="https://images.unsplash.com/photo-1534536281715-e28d76689b4d?auto=format&fit=crop&w=1920&q=85"
          alt="Contact Us Banner"
          style={styles.bannerImage}
        />
        <div style={styles.bannerOverlay} />
        <div style={styles.bannerContent}>
          {/* <div style={styles.bannerBadge}>📞 CONNECT WITH US</div> */}
          <h1 style={styles.bannerTitle}>Contact Us</h1>
          <p style={styles.bannerSubtitle}>We're here to help you every step of the way</p>
        </div>
      </div>

      <div style={styles.section}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
          
          {/* LEFT COLUMN: CONTACT DETAILS (Aligned) */}
          <div style={{ flex: "1 1 500px" }}>
            <h2 style={{ marginBottom: "30px", color: "#333", fontWeight: "800" }}>Get In Touch</h2>
            
            <div className="contact-card" style={styles.infoStyle}>
              <span style={styles.iconStyle}>📍</span>
              <div>
                <h4 style={{ color: primaryColor, margin: "0 0 5px 0" }}>Address</h4>
                <p style={{ color: "#555", margin: 0 }}>Ward No. 1, Gobindpuri Colony, Opp. Reliance Petrol Pump, Pipli Road, Ladwa, Dist. Kurukshetra — 136 132, Haryana</p>
              </div>
            </div>

            <div className="contact-card" style={styles.infoStyle}>
              <span style={styles.iconStyle}>📞</span>
              <div>
                <h4 style={{ color: primaryColor, margin: "0 0 5px 0" }}>Phone</h4>
                <p style={{ color: "#555", margin: 0 }}>+91-90534-90023 | +91-72068-66235</p>
              </div>
            </div>

            <div className="contact-card" style={styles.infoStyle}>
              <span style={styles.iconStyle}>✉️</span>
              <div>
                <h4 style={{ color: primaryColor, margin: "0 0 5px 0" }}>Email</h4>
                <p style={{ color: "#555", margin: 0 }}>dpskidsladwa@gmail.com</p>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: ACTION BOX */}
          <div style={styles.actionBox}>
            <h2 style={{ fontSize: "2rem", marginBottom: "20px", fontWeight: "800" }}>Ready to Visit?</h2>
            <p style={{ marginBottom: "30px", opacity: "0.9", lineHeight: "1.6" }}>
              Experience DPS Kids Ladwa firsthand. Schedule a visit to see our campus and meet our expert educators.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              <button className="cta-btn" onClick={() => setIsModalOpen(true)}>📅 Book a School Visit</button>
              <a href="tel:+919053490023" style={{textDecoration:'none'}}>
                <button className="cta-btn secondary" style={{width:'100%'}}>📞 Call Now</button>
              </a>
            </div>
          </div>
        </div>

        {/* 🗺️ MAP SECTION */}
        <div style={styles.mapContainer}>
          <iframe 
            src={mapUrl} 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            title="School Location"
          ></iframe>
        </div>
      </div>

      {/* 🚀 MODAL FORM (Connected to Email) */}
      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <button style={styles.closeBtn} onClick={() => setIsModalOpen(false)}>×</button>
            <h2 style={{ color: primaryColor, textAlign: "center", marginBottom: "10px" }}>Schedule Visit</h2>
            <p style={{textAlign:'center', fontSize:'0.85rem', color:'#666', marginBottom:'20px'}}>Details will be sent to kipsinstitute149@gmail.com</p>
            
            {/* Formspree integration for Email delivery */}
            <form onSubmit={handleSubmit} style={styles.form}>
              <input type="hidden" name="_to" value="kipsinstitute149@gmail.com" />
              
              <input type="text" name="parent_name" placeholder="Parent's Name" style={styles.input} required />
              <input type="tel" name="phone" placeholder="Phone Number" style={styles.input} required />
              <input type="email" name="email" placeholder="Email Address" style={styles.input} required />
              <input type="date" name="visit_date" style={styles.input} required />
              
              <select name="class" style={styles.input}>
                <option disabled selected>Admission For Class</option>
                <option>Pre-Nursery</option>
                <option>Nursery</option>
                <option>Prep / KG</option>
                <option>Primary</option>
              </select>
              
              <textarea name="message" placeholder="Any specific questions?" style={{ ...styles.input, height: "80px" }}></textarea>
              
              <button type="submit" style={styles.submitBtn} onSubmit={handleSubmit}>Send Visit Request</button>
            </form>
          </div>
        </div>
      )}

      {/* 🔮 STYLES & ANIMATIONS */}
      <style>
        {`
          .contact-card {
            transition: all 0.3s ease;
          }
          .contact-card:hover {
            transform: translateX(10px);
            background: #fff !important;
            box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          }
          .cta-btn {
            padding: 15px;
            border-radius: 30px;
            border: none;
            background: #FFD700;
            color: #000;
            font-weight: bold;
            font-size: 1rem;
            cursor: pointer;
            transition: 0.3s;
          }
          .cta-btn:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 20px rgba(0,0,0,0.2);
          }
          .cta-btn.secondary {
            background: transparent;
            border: 2px solid #fff;
            color: #fff;
          }
          .cta-btn.secondary:hover {
            background: #fff;
            color: ${primaryColor};
          }
          @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
          @keyframes zoomIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        `}
      </style>
    </div>
  );
};

const styles = {
  page: {
    paddingTop: "clamp(80px, 10vw, 140px)",
    backgroundColor: "#fffaf0",
    minHeight: "100vh",
    fontFamily: "'Segoe UI', sans-serif",
    overflowX: "hidden",
     marginTop:-90
  },

  /* 🔥 HERO (RENAMED → bannerHero same rakha) */
  bannerHero: {
    position: "relative",
    width: "100%",
    height: "clamp(250px, 50vw, 560px)", // 🔥 best responsive height
    overflow: "hidden",
    marginTop: "clamp(60px, 8vw, 120px)", // 🔥 spacing fix
   
  },

  bannerImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  bannerOverlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(rgba(0,111,47,0.7), rgba(0,0,0,0.7))",
  },

  bannerContent: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "0 clamp(10px, 4vw, 20px)",
    color: "#fff",
  },

  bannerBadge: {
    background: "#FFD700",
    color: "#000",
    padding: "6px 18px",
    borderRadius: "50px",
    fontWeight: "700",
    marginBottom: "10px",
    fontSize: "clamp(11px, 2vw, 14px)",
  },

  bannerTitle: {
    fontSize: "clamp(22px, 6vw, 52px)", // 🔥 improved scaling
    fontWeight: "900",
    margin: 0,
  },

  bannerSubtitle: {
    fontSize: "clamp(13px, 2.5vw, 20px)",
    opacity: 0.9,
    marginTop: "8px",
  },
  /* 🔥 SECTION FIX */
  section: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "clamp(30px, 6vw, 80px) 15px"
  },

  /* 🔥 INFO CARD FIX */
  infoStyle: {
    display: "flex",
    alignItems: "center",
    gap: "clamp(10px, 3vw, 20px)",
    marginBottom: "15px",
    padding: "clamp(15px, 4vw, 25px)",
    borderRadius: "15px",
    background: "#f8f9fa",
    borderLeft: `6px solid rgb(0, 111, 47)`,
    cursor: "pointer",
    flexWrap: "wrap" // 🔥 mobile fix
  },

  iconStyle: {
    fontSize: "clamp(16px, 3vw, 24px)",
    background: "#fff",
    width: "clamp(40px, 8vw, 50px)",
    height: "clamp(40px, 8vw, 50px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
  },

  /* 🔥 ACTION BOX FIX */
  actionBox: {
    flex: "1 1 300px",
    background: "rgb(0, 111, 47)",
    padding: "clamp(25px, 6vw, 50px)",
    borderRadius: "30px",
    color: "#fff",
    boxShadow: "0 20px 40px rgba(0,111,47,0.3)",
    width: "100%"
  },

  /* 🔥 MAP FIX */
  mapContainer: {
    marginTop: "clamp(40px, 6vw, 80px)",
    borderRadius: "20px",
    overflow: "hidden",
    height: "clamp(250px, 50vw, 450px)", // responsive height
    boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
    border: "clamp(4px, 1vw, 10px) solid #fff"
  },

  /* 🔥 MODAL FIX */
  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "15px" // 🔥 mobile spacing
  },

  modalContent: {
    background: "#fff",
    padding: "clamp(20px, 5vw, 30px)",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "450px",
    position: "relative"
  },

  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "12px",
    fontSize: "clamp(22px, 4vw, 30px)",
    border: "none",
    background: "none",
    cursor: "pointer",
    color: "#666"
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },

  input: {
    padding: "clamp(10px, 2.5vw, 14px)",
    borderRadius: "10px",
    border: "1px solid #eee",
    fontSize: "clamp(13px, 2vw, 16px)",
    background: "#f9f9f9",
    outline: "none"
  },

  submitBtn: {
    padding: "clamp(12px, 3vw, 15px)",
    borderRadius: "10px",
    border: "none",
    background: "rgb(0, 111, 47)",
    color: "#fff",
    fontSize: "clamp(14px, 2.5vw, 18px)",
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: "8px"
  }
};
// const styles = {
//   page: { backgroundColor: "#fff", minHeight: "100vh", fontFamily: "'Segoe UI', sans-serif" },
//   bannerHero: { position: "relative", width: "100%", height: "420px", overflow: "hidden" },
//   bannerImage: { width: "100%", height: "100%", objectFit: "cover" },
//   bannerOverlay: { position: "absolute", inset: 0, background: "linear-gradient(rgba(0,111,47,0.7), rgba(0,0,0,0.7))" },
//   bannerContent: { position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#fff", textAlign: "center" },
//   bannerBadge: { background: "#FFD700", color: "#000", padding: "8px 24px", borderRadius: "50px", fontWeight: "700", marginBottom: "15px" },
//   bannerTitle: { fontSize: "3.5rem", fontWeight: "900", margin: 0 },
//   bannerSubtitle: { fontSize: "1.3rem", opacity: 0.9, marginTop: "10px" },

//   section: { maxWidth: "1100px", margin: "0 auto", padding: "80px 20px" },
  
//   infoStyle: {
//     display: "flex",
//     alignItems: "center",
//     gap: "20px",
//     marginBottom: "20px",
//     padding: "25px",
//     borderRadius: "15px",
//     background: "#f8f9fa",
//     borderLeft: `6px solid rgb(0, 111, 47)`,
//     cursor: "pointer"
//   },
//   iconStyle: {
//     fontSize: "1.5rem",
//     background: "#fff",
//     width: "50px",
//     height: "50px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     borderRadius: "50%",
//     boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
//   },

//   actionBox: { 
//     flex: "1 1 400px", 
//     background: "rgb(0, 111, 47)", 
//     padding: "50px", 
//     borderRadius: "30px", 
//     color: "#fff",
//     boxShadow: "0 20px 40px rgba(0,111,47,0.3)"
//   },
  
//   mapContainer: { marginTop: "80px", borderRadius: "30px", overflow: "hidden", height: "450px", boxShadow: "0 15px 40px rgba(0,0,0,0.1)", border: "10px solid #fff" },

//   // MODAL STYLES
//   modalOverlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, animation: "fadeIn 0.3s" },
//   modalContent: { background: "#fff", padding: "30px", borderRadius: "20px", width: "90%", maxWidth: "450px", position: "relative", animation: "zoomIn 0.3s" },
//   closeBtn: { position: "absolute", top: "15px", right: "15px", fontSize: "30px", border: "none", background: "none", cursor: "pointer", color: "#666" },
//   form: { display: "flex", flexDirection: "column", gap: "12px" },
//   input: { padding: "12px 15px", borderRadius: "10px", border: "1px solid #eee", fontSize: "1rem", background: "#f9f9f9", outline: "none" },
//   submitBtn: { padding: "15px", borderRadius: "10px", border: "none", background: "rgb(0, 111, 47)", color: "#fff", fontSize: "1.1rem", fontWeight: "bold", cursor: "pointer", marginTop: "10px" }
// };

export default ContactUs;